import i18n from '@/i18n'

import Forgot from '@/page/sign/Forgot.vue'
import ChangePassword from '@/page/sign/ChangePassword.vue'
import SignUp from '@/page/sign/Signup.vue'
import SignIn from '@/page/sign/Signin.vue'
import SignInDynamic from '@/page/sign/SigninDynamic.vue'
import RegisterProtocol from '@/page/sign/RegisterProtocol.vue'

export default [
  {
    path: '/signin',
    component: SignIn,
    meta: {
      title: i18n.t('auth.login'),
      forGuest: true,
    },
  },
  {
    path: '/signin/dynamic',
    component: SignInDynamic,
    meta: {
      title: i18n.t('auth.one_key'),
      forGuest: true,
    },
  },
  {
    path: '/signup',
    component: SignUp,
    meta: {
      title: i18n.t('auth.register.name'),
      forGuest: true,
    },
  },
  {
    path: '/signup/protocol',
    component: RegisterProtocol,
    meta: {
      title: i18n.t('auth.register.protocol'),
    },
  },
  {
    path: '/forgot',
    component: Forgot,
    meta: {
      title: i18n.t('auth.forgot.name'),
    },
  },
  {
    path: '/changePassword',
    component: ChangePassword,
    meta: {
      title: i18n.t('auth.change_password.name'),
      requiresAuth: true,
    },
  },
]
